/**
 * @generated SignedSource<<4ee491fce35da34af4f879b9ad0971bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type markMistakesLearnElement_MarkMistakesLearnElementFragment$data = {
  readonly id: string;
  readonly snippets: ReadonlyArray<{
    readonly content: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "markMistakesLearnElement_MarkMistakesLearnElementFragment";
};
export type markMistakesLearnElement_MarkMistakesLearnElementFragment$key = {
  readonly " $data"?: markMistakesLearnElement_MarkMistakesLearnElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"markMistakesLearnElement_MarkMistakesLearnElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "markMistakesLearnElement_MarkMistakesLearnElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarkMistakes_Snippet",
      "kind": "LinkedField",
      "name": "snippets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MarkMistakesLearnElement",
  "abstractKey": null
};

(node as any).hash = "2a0ccaadccfdf1f604c8aeeae54aacf8";

export default node;
